import logoImage from './logo.png';

const Logo = ({ className }) => (
  <img className={className} src={logoImage} alt="ShadowDragon" />
);

export default Logo;
